export default __webpack_public_path__ + "static/media/login.85c82b54.svg";